// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 08.24.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// Shadow objects mimic the height of a target fixed position element. When
// placed after a fixed element, subsequent DOM elements will be pushed down
// by the height of the fixed element, preventing content overlap.
// -----------------------------------------------------------------------------

const Shadow = (($) => {
  const SELECTOR = '.js-shadow'

  /* --------------------------------------------------------------------------
    Private
  -------------------------------------------------------------------------- */

  function syncAll () {
    for (let shadow of $(SELECTOR)) {
      Shadow.sync($(shadow).data('target'))
    }
  }

  /* --------------------------------------------------------------------------
    Public
  -------------------------------------------------------------------------- */

  let Shadow = {
    init () {
      syncAll() // Sync on initial load
      $(window).on('load', syncAll) // Sync again on page load complete
      $(window).resize(syncAll) // Sync again if user resizes window
    },
    // Sync the shadow for a specific target element
    // @param targetId - the id of the element used as the `data-target` of the
    //                   shadow to be synced.
    sync (targetId) {
      let $shadow = $(`[data-target='${targetId}']`)
      $shadow.height($(targetId).outerHeight(true))
    }
  }

  return Shadow
})(jQuery)

export default Shadow
